export default __webpack_public_path__ + "static/media/greenery-desktop.d92d75e9.jpg";